// extracted by mini-css-extract-plugin
export default {"BannerList":"Banner_BannerList__Mh-ZU"};